// utility for determining if browser is at mobile breakpoint (576 matches breakpoint defined in cssConstants)
// Note: should use media queries instead of this helper when possible for mobile support.
export const isMobile = () => {
  return window.innerWidth > 0 ? window.innerWidth <= 576 : window.screen.width <= 576;
};
